import { memo } from "react";
import { NodeProps } from "reactflow";
import { NodeData, NodeType } from "../../../models/nodeType";
import { useForm } from "react-hook-form";
import FlowNode from "./FlowNode";
import { Stack } from "@chakra-ui/react";
import { useUpdateNodeData } from "../../../hooks/useUpdateNodeData";
import { Form } from "react-router-dom";
import SelectTimeOfDay from "../../base/SelectTimeOfDay";

interface WaitForTimeOfDayNodeData extends NodeData {
  timeOfDay: string;
}

function WaitForTimeOfDayNode(props: NodeProps<NodeType<WaitForTimeOfDayNodeData>>) {
  const {
    id: nodeId,
    data: { color, nodeData },
  } = props;

  const timeOfDay = nodeData.timeOfDay ?? "day";

  const { getValues, setValue, handleSubmit } = useForm<WaitForTimeOfDayNodeData>({
    defaultValues: { timeOfDay },
    mode: "onBlur",
  });

  const { updateNodeData } = useUpdateNodeData<WaitForTimeOfDayNodeData>(nodeId);

  return (
    <FlowNode {...props}>
      <Stack>
        <Form onSubmit={handleSubmit(updateNodeData)} onBlur={handleSubmit(updateNodeData)}>
          <Stack>
            <SelectTimeOfDay
              color={color}
              value={getValues("timeOfDay")}
              setValue={(value) => setValue("timeOfDay", value)}
            />
          </Stack>
        </Form>
      </Stack>
    </FlowNode>
  );
}

export default memo(WaitForTimeOfDayNode);
